import {Directive, effect, ElementRef, inject, input} from '@angular/core';
import {CheckboxComponent} from '../../components/checkbox/checkbox.component';
import {startWith} from 'rxjs/operators';
import {TooltipService} from '../../tooltip';
import {ExtendedTippyInstance} from '@ngneat/helipopper';
import {Placement} from 'tippy.js';

@Directive({
  selector: 'ms-checkbox[msCheckboxTooltip]',
  standalone: true,
})
export class CheckboxTooltipDirective {
  readonly toggleOnTooltip = input<string | null>(null);
  readonly toggleOffTooltip = input<string | null>(null);
  readonly isTooltipAvailable = input(false);
  readonly tooltipPlacement = input<Placement>('top');

  private readonly checkbox = inject(CheckboxComponent, {host: true});
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly tooltipService = inject(TooltipService);

  private tooltip?: ExtendedTippyInstance<string>;

  private readonly tooltipEffect = effect(onCleanup => {
    const isTooltipAvailable = this.isTooltipAvailable();
    const toggleOnTooltip = this.toggleOnTooltip();
    const toggleOffTooltip = this.toggleOffTooltip();
    const tooltipPlacement = this.tooltipPlacement();

    this.destroyTooltip();

    if (!isTooltipAvailable) {
      return;
    }

    const subscription = this.checkbox.checked$.pipe(startWith(this.checkbox.checked)).subscribe(checked => {
      this.destroyTooltip();

      const tooltip = checked ? toggleOnTooltip : toggleOffTooltip;

      if (!tooltip) {
        return;
      }

      this.tooltip = this.tooltipService.create(this.elementRef.nativeElement, tooltip, {placement: tooltipPlacement});
    });

    onCleanup(() => {
      subscription.unsubscribe();
      this.destroyTooltip();
    });
  });

  private destroyTooltip(): void {
    this.tooltip?.destroy();
    this.tooltip = undefined;
  }
}
